<template>
	<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="1.6"
		stroke-linecap="round" stroke-linejoin="round" fill="none" />
	<circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
		stroke-linejoin="round" fill="none" />
	<path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="1.6"
		stroke-linecap="round" stroke-linejoin="round" fill="none" />
</template>
